import React from "react";
import {Label} from "reactstrap";

export const PADDING_STYLE = {paddingTop: "0.375rem", paddingBottom:"0px"};

export default class CreateObjectLabel extends React.Component {

  render() {
    return <Label style={{...PADDING_STYLE, ...this.props.style}}>
      {this.props.children}
    </Label>
  }
}
